import { Grid, Toolbar } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { SidebarItemsType } from "../../models/sidebar";
import { isNullOrEmpty } from "../../utils/helper";
import "./MobileNavBar.scss";
import MobileNavBarPopup from "./components/MobileNavBarPopup";

interface MobileNavBarProps {
  items: {
    title: string;
    pages: SidebarItemsType[];
  }[];
}

export default function MobileNavBar(props: MobileNavBarProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { items } = props;

  const [isEndOfPage, setIsEndOfPage] = useState(true);
  const [openedMenu, setOpenedMenu] = useState<SidebarItemsType>();

  const getInitialSelectedMenu = (): SidebarItemsType | undefined => {
    let currentMenu: SidebarItemsType | undefined;
    items.forEach((item) => {
      const foundItem = item.pages.find((p) => p.href === location.pathname);
      if (foundItem) {
        currentMenu = foundItem;
        return;
      }
    });
    if (!currentMenu) return undefined;
    else return currentMenu;
  };

  const clickMenu = (page: SidebarItemsType) => {
    if (isNullOrEmpty(page.children)) {
      navigate(page.href, { state: { refreshAt: Date.now() } });
    } else {
      setOpenedMenu(page);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;

      if (windowHeight + scrollTop >= documentHeight) {
        setIsEndOfPage(true);
      } else {
        setIsEndOfPage(false);
      }
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  const selectedMenu = getInitialSelectedMenu();

  return (
    <>
      <Toolbar
        className={
          "mobile-nav-bar" + (isEndOfPage ? " mobile-nav-bar-eop" : "")
        }
      >
        {items.map((item) => {
          return (
            <Grid
              key={item.title}
              container
              justifyContent="space-around"
              alignItems="center"
            >
              {item.pages.map((page) => {
                return (
                  <Grid
                    onClick={() => clickMenu(page)}
                    key={page.title}
                    id={"mobile-nav-bar-item-" + page.title}
                    item
                    data-testid={"mobile-nav-bar-item-" + page.title}
                    className={
                      selectedMenu?.title === page.title ||
                      openedMenu?.title === page.title
                        ? "mobile-nav-bar-selected"
                        : ""
                    }
                  >
                    <Grid textAlign="center" item>
                      {page.icon}
                    </Grid>
                    <Grid
                      className="mobile-nav-bar-text"
                      textAlign="center"
                      item
                    >
                      {page.title}
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          );
        })}
      </Toolbar>
      <MobileNavBarPopup
        isOpen={!isNullOrEmpty(openedMenu)}
        handleClose={() => setOpenedMenu(undefined)}
        item={openedMenu}
      />
    </>
  );
}
